var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { SegmentEvent, CDNDefaultSettings } from '../Utils/Constants';
import P2PLoader from './P2PLoader';
import CDNLoader from './CDNLoader';
import SegmentStorage from '../Storage/SegmentStorage';
import { VideoSegment } from '../Storage/VideoSegment';
import Utils from '../Utils/Utils';
import Resource from '../Resource/Resource';
import BalancerApiBusinessObject from '../BusinessObjects/BalancerApiBusinessObject';
import BandwithLimiterBusinessObject from '../BusinessObjects/BandwidthLimiterBusinessObject';
import TestProfilesBusinessObject from '../BusinessObjects/TestProfilesBusinessObject';
import StatsReportingBusinessObject from '../BusinessObjects/StatsReportingBusinessObject';
import Logger from './../Utils/Logger';
import { v4 as uuidv4 } from 'uuid';
/**
 * @class
 * @description Request load main class, it manages and chooses between CDN and P2P requests and evaluates the requests.
 * @exports Loader
 */
export default class Loader {
    /**
     * Constructs loader.
     * @param {Options} options Options object.
     */
    constructor(options) {
        this._segments = new Map();
        this.segmentsMap = new Map(); // NEW segment vs old segment
        this.isEnabled = true;
        this._options = options;
        this._resource = new Resource();
        this.storage = new SegmentStorage(this);
        this.CDNLoader = new CDNLoader(options, this._resource);
        this.P2PLoader = new P2PLoader(options, this.storage);
        TestProfilesBusinessObject.getInstance(this);
        this.uuid = uuidv4();
        // Get Data from Balancer API and initialize CDN AND P2P Loaders 
        let balancerApiBusinessObject = new BalancerApiBusinessObject(this);
        this._balancerBusinessObject = balancerApiBusinessObject;
    }
    loadCDNBalancerData() {
        if (this._options.resource != undefined && this._options.resource != '') {
            this._balancerBusinessObject.loadBalancerData(this._options.accountCode, this._options.resource, this._options.isLive, this._options.updateTime, this._options.debug == true ? true : false, this._options.isDev == true ? true : false, this._options.applicationCode, this._options.originCode);
        }
    }
    /**
     * Chooses to request to CDN or P2P and manages the response calling the callback.
     * @param {URL} url URL object for the request.
     * @param {callback} callback Callback method to call back when loaded.F
     * @param {Object} headers Optional headers of the request.
     * @param {number} retries Number of retries before giving up to load a segment if it fails, optional.
     * @param {boolean} forceArrayBuffer False by default, set as true if is expected to get the manifest response
     * in ArrayBuffer format.
     * @public
     */
    processSegment(url, download, callbacks, headers, retries = CDNDefaultSettings.retries, forceArrayBuffer = false, stats) {
        var _a, _b;
        const isMedia = Utils.isMedia(url.pathname);
        const isManifest = isMedia ? false : Utils.isManifest(url.pathname);
        const useP2P = this.P2PLoader.isEnabled && isMedia;
        const newSegment = new VideoSegment(url.pathname, url.href, this._resource, headers, retries, useP2P, forceArrayBuffer);
        newSegment.download = download;
        newSegment.headers = headers;
        this._segments.set(newSegment.id, newSegment);
        // If is not manifest assing rendition to the current segment to have more data.
        if (!isManifest) {
            let rendition = this._resource.getRendition(url.pathname);
            if (rendition != undefined) {
                Logger.log("Detected rendition -> " + rendition.bandwidth + " " + (rendition === null || rendition === void 0 ? void 0 : rendition.bandwidthPosition) + " isAudio " + rendition.isAudio + " for " + url);
                newSegment.duration = rendition.targetDuration;
                newSegment.rendition = rendition;
                if (!rendition.isAudio) {
                    this.CDNLoader.currentRenditionBandwidth = rendition.bandwidth;
                    this.CDNLoader.currentRenditionPos = rendition.bandwidthPosition + 1;
                    this.CDNLoader.renditionCount = this._resource.getVideoRenditions().size;
                }
            }
        }
        let reporting = StatsReportingBusinessObject.getInstance(this);
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore-next-line
        let id = (_b = (_a = window === null || window === void 0 ? void 0 : window.plugin) === null || _a === void 0 ? void 0 : _a.viewTransform) === null || _b === void 0 ? void 0 : _b.getViewCode();
        if (!id) {
            id = this.uuid;
        }
        reporting.start("d1.npaw.com", id, this._options.accountCode, this._options.applicationCode, url.toString());
        newSegment.isManifest = isManifest;
        newSegment.isMedia = isMedia;
        // Doesn't declare it if we doesn't donload teh content
        if (download) {
            newSegment.on(SegmentEvent.Success, (e) => __awaiter(this, void 0, void 0, function* () {
                this.onProcessSegmentSuccess(newSegment);
                callbacks[0](newSegment);
            }));
            newSegment.on(SegmentEvent.Fail, (e) => {
                this.onProcessSegmentFail(newSegment, true);
                if (newSegment.retries == 0)
                    if (callbacks.length > 1) {
                        callbacks[1]();
                    }
                console.error(`Segment request failed, no more retries ${newSegment.route}`);
            });
        }
        //Logger.log("VIA P2P "+newSegment.useP2P+" -> "+url);
        let segmenIsAvailableFromAPeer = false;
        // if(  newSegment.useP2P ){
        //    segmenIsAvailableFromAPeer = this.P2PLoader.request(newSegment);
        // }
        // If p2p, tries to use load via p2p, if not, cdn
        //if ( !segmenIsAvailableFromAPeer   ) {
        this.CDNLoader.updateUrl(newSegment);
        this.CDNLoader.getActiveRequests().set(newSegment.id, newSegment);
        /* }else{
         // this.CDNLoader.updateUrl( newSegment );
         // newSegment.finalUrl = url.toString();
          newSegment.cdnName="P2P";
          newSegment.cdnProvider="P2P";
  
          Logger.log("LOADED VIA P2P "+newSegment.id+" "+newSegment.finalUrl+" "+segmenIsAvailableFromAPeer);
        }*/
        newSegment.startTime = Date.now();
        return newSegment;
    }
    onProcessSegmentFail(segment, retry) {
        const cdnName = segment.cdnName;
        segment.failed = true;
        // Update CDN Loader stats 
        this.CDNLoader.updateCDNStatsOnFailure(cdnName, segment);
        if (segment.triedP2P && segment.useP2P == true) {
            segment.useP2P = false;
            this.CDNLoader.updateUrl(segment);
        }
    }
    onProcessSegmentSuccess(segment) {
        let testProfiles = TestProfilesBusinessObject.getInstance();
        testProfiles.push(segment);
        segment.off(SegmentEvent.Success);
        segment.off(SegmentEvent.Fail);
        let maxBandwith = this.CDNLoader.getMaxBandwidth(segment.cdnName);
        if (maxBandwith > 0) {
            let limiter = new BandwithLimiterBusinessObject();
            limiter.limit(maxBandwith, segment);
        }
        // Update CDN Loader stats
        this.CDNLoader.updateCDNStatsOnSuccess(segment);
        // Update active segments
        this.CDNLoader.removeActiveSegment(segment);
        // Store the media
        if (this.P2PLoader.isEnabled && segment.isMedia) {
            let storedSegment = this.P2PLoader.getSegment(segment);
            if (!storedSegment)
                this.P2PLoader.storeSegment(segment);
            else
                storedSegment.readyForP2P = true;
        }
        // Delete segment from map
        this._segments.delete(segment.id);
    }
    /**
     * Returns the map of unfinished/active CDN requests.
     * @returns {Map<string,VideoSegment>} The map with the requests.
     * @public
     */
    /*public getActiveCdnDownloads(): Map<string, VideoSegment> {
      return this.CDNLoader.getActiveRequests();
    }*/
    enableCDN(name, enabled) {
        /*if (name === 'P2P') {
          if (this.P2PLoader.enabled !== enabled) {
            this.P2PLoader.enabled = enabled;
            return true;
          }
          return false;
        }*/
        return this.CDNLoader.enableCDN(name, enabled) || false;
    }
    setMaxBandwith(name, bandwidth) {
        if (name === 'P2P') {
            return false;
        }
        return this.CDNLoader.setMaxBandwidth(name, bandwidth) || false;
    }
    loadEM(xhr, url, e) {
    }
    ;
    loadStartEM(xhr, segment, e) {
        if (segment != undefined && e.total > 0 && this.P2PLoader.isEnabled && segment.isMedia && !this.P2PLoader.getSegment(segment) && xhr.response && xhr.response.byteLength && xhr.response.byteLength > 0) {
            segment.data = xhr.response; // Store the response
            segment.realBodySize = e.total;
            this.P2PLoader.storeSegment(segment);
        }
    }
    ;
    progressEM(xhr, segment, e) {
        if (segment != undefined) {
            // Store the media before having it clompletly downloaded
            //console.log("P2P5 Storing? "+segment.id+" "+segment.isMedia+" "+this.P2PLoader.getSegment( segment )+" "+xhr.response.byteLength);
            if (this.P2PLoader.isEnabled && segment.isMedia && !this.P2PLoader.getSegment(segment) && xhr.response && xhr.response.byteLength && xhr.response.byteLength > 0) {
                Logger.log("the status is -> " + xhr.status);
                segment.data = xhr.response; // Store the response
                if (e.total > 0) {
                    segment.realBodySize = e.total;
                }
                //console.log("P2P5 Storing on progress "+segment.id+" "+segment.realBodySize);
                this.P2PLoader.storeSegment(segment);
            }
            segment.onProgress(xhr, e);
            this.CDNLoader.updateProgressStats();
        }
    }
    ;
    // Update theoplayer interceptor
    /* public getSegment( url: string,headers: { [key: string]: string } ) : VideoSegment | undefined{
     
       const header = headers?.Range || '';
   
       let segment = this._segments.get( url+header );
       return segment;
   
     }
   
     public getSegmentOriginalUrl( url: string,headers: { [key: string]: string } ) : String | undefined {
     
       const header = headers?.Range || '';
   
       let segment = this._segments.get( url+header );
       return segment?.origRes;
   
   
     }*/
    readyStateChangeEM(xhr, segment) {
        const response = xhr.response;
        switch (xhr.readyState) {
            case 4: //Done
                if (segment != undefined) {
                    if (xhr.status >= 400 || xhr.status < 200) {
                        Logger.log("SEGMENT FAILED -> " + segment.id);
                        this.onProcessSegmentFail(segment, false);
                        return false;
                    }
                    else {
                        let ok = segment.onSuccess(xhr.response);
                        if (ok) {
                            this.onProcessSegmentSuccess(segment);
                        }
                        else {
                            this.onProcessSegmentFail(segment, false);
                        }
                        return true;
                    }
                }
                else {
                    //("[NPAW] -> Undefined segment");
                }
                break;
        }
        return true;
    }
    ;
    loadEndEM(xhr, segment, e) {
    }
    ;
    errorEM(xhr, segment, e) {
    }
    ;
    getStats() {
        let cdnStats = this.CDNLoader.getStats();
        let p2pStats = this.P2PLoader.getStats();
        let p2pUsedOnce = false;
        let p2pAverageBandwidth = 0;
        if (p2pStats && this.P2PLoader && this.CDNLoader.getStats().totalDownloadedBytes > 0) {
            p2pUsedOnce = true;
            p2pAverageBandwidth = (p2pStats.downloadedBytes * 8) / (p2pStats.downloadMillis / 1000);
        }
        if (this.P2PLoader.isEnabled) {
            cdnStats.cdns.push({
                downloadedBytes: p2pStats.downloadedBytes || 0,
                downloadedChunks: p2pStats.downloadedSegments || 0,
                bandwidth: Math.trunc(p2pAverageBandwidth || 0),
                instantBandwidth: Math.trunc(0),
                lastInstantBandwidth: Math.trunc(0),
                peakBandwidth: Math.trunc(0),
                failures: 0,
                totalFailures: 0,
                retries: 0,
                downloadTime: p2pStats.downloadMillis,
                provider: "P2P",
                profileName: "P2P",
                isActive: this.P2PLoader.isEnabled,
                ptb: 0,
                usedOnce: p2pUsedOnce,
                hugeChunks: 0,
                firstHugeChunkSize: 0,
                lastChunksLapse: 0,
                maxBandwidth: 0,
                banned: false,
                lastBandwidth: 0,
                scoringBandwidth: 0,
            });
            cdnStats.totalBandwidth = cdnStats.totalBandwidth + (p2pStats.downloadAvgBw || 0);
            cdnStats.totalDownloadedBytes = cdnStats.totalDownloadedBytes + (p2pStats.downloadedBytes || 0);
        }
        return cdnStats;
    }
    enable() {
        this.isEnabled = true;
    }
    disable() {
        this.isEnabled = false;
    }
    getIsEnabled() {
        return this.isEnabled;
    }
}
